export const useFirebaseEmulators = false;

export const firebase = {
	production: true,
	Cfg: {
		apiKey: 'AIzaSyDTp4UjIVJ-9FJNWw2sFRV6uEeqQx_XbDc',
		authDomain: 'martial-art-solutions.firebaseapp.com',
		projectId: 'martial-art-solutions',
		storageBucket: 'martial-art-solutions.firebasestorage.app',
		messagingSenderId: '898242812861',
		appId: '1:898242812861:web:d5a437ee925e9ac52310d4',
		measurementId: 'G-HHDC6DFN93',
		twilioEndpoint: 'https://twilio-agwzindyha-uc.a.run.app',
		sandboxEndpoint: 'https://sandbox-agwzindyha-uc.a.run.app',
		emulatorEndpoint: 'http://localhost:5001/martial-art-solutions/us-central1',
	},
	googleDomain: 'yongsa.net',
	offSetDays: 1,
	PayPal_Client_Id: 'AT7N55QgBstZFh1VPSXCsGLt2NBi94EOEpIthf3eVhInpePmMw2o7-08iZv_yOeUzpS5jjcmtPFvWAGY',
};
